import React, { useState } from 'react';
import SendToDeliveryAgencyButtonProperties from "./SendToDeliveryAgencyButtonProperties";
import SendToDeliveryAgencyStore from "./SendToDeliveryAgencyStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import TypeCorrespondSelectionDialog from "./TypeCorrespondSelectionDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import SendIcon from '@mui/icons-material/Send';
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import TypeCorrespond from "../../../entities/TypeCorrespond";


const SendToDeliveryAgencyButton: React.FC<SendToDeliveryAgencyButtonProperties> = ({
                                                                        onClick = () => {
                                                                        },
                                                                        onSave = () => {
                                                                        },
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        packageDeliveryOrderId,
                                                                        rounded = false,
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {

    const [dialogOpen, setDialogOpen] = useState(false);
    const userStore = useUserContext();
    const commonContext = useCommonContext();

    const store = new SendToDeliveryAgencyStore(commonContext, packageDeliveryOrderId);

    const handleOnclick = () => {
        onClick();
        setDialogOpen(true);
    }

    const handleConfirm = async (typeCorrespond: TypeCorrespond) => {
        const success = await store.sendToDeliveryAgency(typeCorrespond);
        if (success) {
            onSave();
        }
        setDialogOpen(false);
    }

    const handleClose = () => {
        if (!store.loading) {
            setDialogOpen(false);
        }
    }

    const text = "Crear envío en Solved";
    if (!userStore.hasAccess(Access.CREATE_EDIT_PACKAGE_DELIVERY_ORDER.valueOf())) {
        return <></>;
    }

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled || store.loading}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <SendIcon/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled || store.loading}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <SendIcon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <>
                <Btn/>
                <TypeCorrespondSelectionDialog
                    open={dialogOpen}
                    loading={store.loading}
                    onClose={handleClose}
                    onConfirm={handleConfirm}
                />
            </>
        )}
    </Observer>
}

export default SendToDeliveryAgencyButton;



